









































//import { functions,auth, authObject} from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes"
import { ValidationObserver } from 'vee-validate'
import Notice from "@/components/Notice.vue"
import { Component,Mixins } from "vue-property-decorator";
import Common from '@/mixins/common';

@Component({
  components: {
    Notice,
  }
})

export default class SelectSchool extends Mixins(Common) {
  isLoading = false
  selectSchoolId = ''
  notice: NoticeProps = {}
  schoolsPublicProfile: object[] = []
  
  get observer() {
    return this.$refs.selectSchoolValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get isDisabled(){
    return this.schoolsPublicProfile.length === 0 || this.selectSchoolId === this.$store.getters.schoolId
  }

  async created(){
    console.trace('created');
    this.selectSchoolId = this.$store.getters.schoolId

    const schools = await this.$getSchoolsPublicProfileQuery().get()

    this.schoolsPublicProfile = schools.docs.map((doc) => {
      return doc.data()
    })
  }
 
  mounted(){
    console.trace('mounted');
 }

  destroyed() {
    console.trace('destroyed');
  }

  async selectSchool() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! await this.observer.validate()){
        return
      }

      this.$store.commit("setLoading",true);
      this.isLoading = true
   
      this.$store.commit("setSchoolId", this.selectSchoolId);

      this.notice = {
        message: this.$t('selectSchool.selected') as string,
        duration: 0,
        isShow: true,
        type: {'is-info': true}
      }
      this.observer.reset()
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('selectSchool.error') as string

      const errorMessage1 = this.$getErrorMessage(errorCode)

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
